import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@barracuda-internal/bds-core';

/**
 * Role guard for the Support SPA (AAD-authenticated users).
 *
 * Reads `state.auth.roles` (string[]) established by Task 10's authReducer.
 * Renders `children` when the session satisfies `requires`:
 *   - ADMIN role always bypasses any requirement.
 *   - Otherwise, at least one role in the session must be in `requires`.
 *
 * Usage:
 *   <AADRoleGuard requires="ADMIN">...</AADRoleGuard>
 *   <AADRoleGuard requires={["ADMIN", "OPS"]}>...</AADRoleGuard>
 */
const AADRoleGuard = ({ requires, children }) => {
  const roles = useSelector((s) => s.auth.roles) || [];
  const rolesSet = new Set(roles);
  const requiredList = Array.isArray(requires) ? requires : [requires];

  const admin = rolesSet.has('ADMIN');
  const ok = admin || requiredList.some((r) => rolesSet.has(r));

  if (ok) return <>{children}</>;

  return (
    <Alert bdsType="neutralError">
      You don&apos;t have access to this action. Contact IT if you believe this is a mistake.
    </Alert>
  );
};

export default AADRoleGuard;
